<template>
    <el-container>
        <el-drawer title="菜单设置" :visible="topMenuSettingVisible" :before-close="handleClose" append-to-body
                   :wrapperClosable="false" @open="handleOpen">
            <div style="height: calc(100% - 71px);">
                <el-scrollbar class="drawer_scrollbar">
                    <el-row style="padding: 30px">
                        <el-tree
                                ref="tree"
                                node-key="id"
                                show-checkbox
                                default-expand-all
                                :data="treeData"
                                :default-checked-keys="defaultCheckedKeys"
                                :props="defaultProps">
                        </el-tree>
                    </el-row>
                </el-scrollbar>
            </div>
            <el-row class="drawer_footer">
                <el-button type="primary" @click="submit" :disabled="$store.state.loading">确 定</el-button>
                <el-button @click="handleClose" :disabled="$store.state.loading">取 消</el-button>
            </el-row>
        </el-drawer>
    </el-container>
</template>

<script>
    export default {
        name: "SysTopMenuSetting",
        props: ['topMenuSettingVisible', 'selData'],
        data() {
            return {
                treeData: [],
                defaultCheckedKeys: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                noChildrenIds:[]
            }
        },
        methods: {
            async handleOpen() {
                let treeResp = await this.postRequest('/sysMenu/findTree', {});
                this.treeData = treeResp.obj;
                let topMenuSettingResp = await this.postRequest('/sysTopMenu/topMenuSettingList', {
                    topMenuId: this.selData.id,
                });

                let checkIds = [];
                this.makeNoChildrenIds(this.treeData);
                topMenuSettingResp.obj.forEach(ele => {
                    //为了解决菜单子节点在全部选中状态下，新增菜单后因为上级菜单已经为选中状态，会把新增的菜单也显示为选中状态的问题；
                    if (this.noChildrenIds.indexOf(ele.menuId) != -1) {
                        checkIds.push(ele.menuId);
                    }
                });
                this.defaultCheckedKeys = checkIds;
            },
            makeNoChildrenIds(treeData) {
                treeData.forEach(ele => {
                    if (ele.children && ele.children != 'null' && ele.children.length > 0) {
                        this.makeNoChildrenIds(ele.children)
                    } else {
                        this.noChildrenIds.push(ele.id);
                    }
                });
            },
            handleClose() {
                this.treeData = [];
                this.defaultCheckedKeys = [];
                this.$refs.tree.setCheckedKeys([]);
                this.$emit('update:topMenuSettingVisible', false);
            },
            async submit() {
                let checkMenuIds = this.$refs.tree.getCheckedKeys();
                checkMenuIds = checkMenuIds.concat(this.$refs.tree.getHalfCheckedKeys())
                await this.postRequest('/sysTopMenu/grant', {
                    topMenuId: this.selData.id,
                    checkedMenuIds: checkMenuIds.toString(),
                });
                this.handleClose();
                this.$message({message: '设置成功', type: 'success'});
            }
        }
    }
</script>

<style scoped>

</style>